import { MedicareApiPlan, SunfireGapPlan, SunfirePlanDetails } from 'types/api';
import { formatCurrency } from './formatters';
import { DEFAULT_PLAN_YEAR } from 'lib/planYears';

export interface FormattedPlanDetails {
  monthlyPremium: string;
  deductible: string;
  oopm: string;
  drugDeductible: string;
}

export function formatPlanDetails(plan: MedicareApiPlan): FormattedPlanDetails {
  const planDetails =
    plan.type === 'gap'
      ? (plan.plan as SunfireGapPlan)
      : (plan.plan_details as SunfirePlanDetails);

  const hasMedicalDeductible = Object.hasOwn(planDetails, 'medicalDeductible');
  const hasDeductible = Object.hasOwn(planDetails, 'deductible');
  const hasMoop = Object.hasOwn(planDetails, 'moop');

  return {
    monthlyPremium: plan.monthly_premium
      ? formatCurrency(plan.monthly_premium)
      : '$0',
    deductible: hasMedicalDeductible
      ? formatCurrency((planDetails as SunfirePlanDetails).medicalDeductible)
      : '$0',
    oopm: hasMoop
      ? formatCurrency((planDetails as SunfirePlanDetails).moop)
      : 'N/A',
    drugDeductible:
      hasDeductible && hasMedicalDeductible
        ? formatCurrency(
            (planDetails as SunfirePlanDetails).deductible -
              (planDetails as SunfirePlanDetails).medicalDeductible
          )
        : '$0',
  };
}

export function getPlanDetailsUrl(
  plan: MedicareApiPlan,
  userId?: string,
  location?: { zipcode?: string; countyFips?: string; state?: string },
  planYear = DEFAULT_PLAN_YEAR
): string {
  const baseUrl = `/browse/details/${planYear}/${
    plan.type
  }/${encodeURIComponent(String(plan.id))}`;

  if (userId && location?.zipcode) {
    const params = new URLSearchParams();
    params.set('userId', userId);
    params.set('zip', location.zipcode);
    if (location.countyFips) params.set('county', location.countyFips);
    if (location.state) params.set('state', location.state);

    return `${baseUrl}?${params.toString()}`;
  }

  return baseUrl;
}
